export const HIDE_TRANSPORT_OVERLAY = 'HIDE_TRANSPORT_OVERLAY';
export const TOGGLE_TRANSPORT_OVERLAY = 'TOGGLE_TRANSPORT_OVERLAY';
export const SHOW_TRANSPORT_OVERLAY = 'SHOW_TRANSPORT_OVERLAY';
export const TRANSPORT_OVERLAY_PLAY_QUEUE = 'TRANSPORT_OVERLAY_PLAY_QUEUE';
export const TRANSPORT_OVERLAY_ACTIVE_QUEUES = 'TRANSPORT_OVERLAY_ACTIVE_QUEUES';
export const START_TRANSPORT_HOVERING = 'START_TRANSPORT_HOVERING';
export const END_TRANSPORT_HOVERING = 'END_TRANSPORT_HOVERING';
